import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function AboutCredentials() {
  const headerRef = useScrollAnimation({ threshold: 0.15 });
  const certsRef = useScrollAnimation({ threshold: 0.15, staggerChildren: 100 });
  const specsHeaderRef = useScrollAnimation({ threshold: 0.15 });
  const specsRef = useScrollAnimation({ threshold: 0.15, staggerChildren: 100 });
  const timelineHeaderRef = useScrollAnimation({ threshold: 0.15 });
  const timelineRef = useScrollAnimation({ threshold: 0.15, staggerChildren: 150 });

  const certifications = [
    { icon: 'ri-medal-line', title: 'Certified Personal Trainer', description: 'Advanced certification in strength training, program design, and client assessment' },
    { icon: 'ri-restaurant-line', title: 'Nutrition Specialist', description: 'Expert in macro tracking, meal planning, and sustainable nutrition strategies' },
    { icon: 'ri-trophy-line', title: 'Competitive Bodybuilder', description: 'Stage tested experience with proven competition prep and peak conditioning' },
    { icon: 'ri-heart-pulse-line', title: 'Transformation Coach', description: 'Specialized in body recomposition, fat loss, and muscle building protocols' },
  ];

  const specializations = [
    {
      image: 'https://public.readdy.ai/ai/img_res/61fc3f30ba3b184dbdb8d507ba474cc9.jpg',
      title: 'Body Transformation',
      description: 'Complete physique overhauls with sustainable results',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=healthy%20meal%20prep%20nutrition%20coaching%20concept%2C%20colorful%20fresh%20vegetables%20proteins%20and%20macros%20laid%20out%20on%20clean%20white%20surface%2C%20top%20down%20flat%20lay%2C%20professional%20food%20photography%2C%20vibrant%20colors%2C%20minimalist%20background%2C%20high%20resolution%2C%20appetizing%20and%20clean&width=400&height=300&seq=spec2&orientation=landscape',
      title: 'Nutrition Coaching',
      description: 'Personalized meal plans and macro strategies',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=man%20doing%20virtual%20online%20coaching%20workout%20at%20home%20with%20laptop%20screen%20showing%20trainer%2C%20modern%20home%20gym%20setup%2C%20clean%20bright%20room%2C%20professional%20fitness%20photography%2C%20motivational%20atmosphere%2C%20natural%20light%2C%20high%20quality%2C%20sharp%20focus&width=400&height=300&seq=spec3&orientation=landscape',
      title: 'Virtual Coaching',
      description: 'World class training from anywhere on the planet',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=focused%20determined%20athlete%20in%20deep%20mindset%20meditation%20before%20training%2C%20eyes%20closed%2C%20calm%20powerful%20expression%2C%20gym%20background%20with%20soft%20bokeh%2C%20motivational%20mindset%20concept%2C%20professional%20photography%2C%20warm%20tones%2C%20cinematic%20lighting&width=400&height=300&seq=spec4&orientation=landscape',
      title: 'Mindset Development',
      description: 'Building the Legacy Mindset for lasting change',
    },
  ];

  const timeline = [
    { icon: 'ri-map-pin-line', city: 'Ottawa', year: '2009', description: 'Where it all began, building the foundation and transforming local lives' },
    { icon: 'ri-building-line', city: 'Toronto', year: '2015', description: "Expanded operations to Canada's largest city, scaling impact and reach" },
    { icon: 'ri-flag-line', city: 'Canada Wide', year: '2020', description: 'Virtual coaching launched, serving clients coast to coast' },
    { icon: 'ri-earth-line', city: 'Global', year: '2025', description: 'The Legacy goes worldwide, transforming lives across continents' },
  ];

  return (
    <section className="py-16 sm:py-20 sm:py-24" style={{ background: '#fafafa' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Certifications */}
        <div className="mb-14 sm:mb-20">
          <div ref={headerRef} className="text-center mb-10 sm:mb-12 scroll-animate-fade-up">
            <div className="inline-block mb-3">
              <span
                className="text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full"
                style={{ background: 'linear-gradient(90deg, #B8860B, #d4a017)', color: '#000000' }}
              >
                Credentials and Expertise
              </span>
            </div>
            <h2
              className="text-3xl sm:text-4xl font-bold mb-4"
              style={{ color: '#B8860B' }}
            >
              Proven Track Record
            </h2>
            <p className="text-base max-w-2xl mx-auto" style={{ color: '#555555' }}>
              Over 15 years of certifications, competition experience, and real world results
            </p>
          </div>

          <div ref={certsRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
            {certifications.map((cert, index) => (
              <div
                key={index}
                className="p-5 sm:p-6 rounded-lg transition-all duration-300 cursor-pointer bg-white scroll-animate-stagger"
                style={{ border: '2px solid #B8860B' }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.borderColor = '#8B0000';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(139,0,0,0.15)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = '#B8860B';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div
                  className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center rounded-full mb-4"
                  style={{ background: 'linear-gradient(135deg, #B8860B, #d4a017)' }}
                >
                  <i className={`${cert.icon} text-xl sm:text-2xl`} style={{ color: '#000000' }}></i>
                </div>
                <h3 className="text-sm sm:text-base font-bold mb-2" style={{ color: '#B8860B' }}>
                  {cert.title}
                </h3>
                <p className="text-sm leading-relaxed" style={{ color: '#555555' }}>
                  {cert.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Specializations */}
        <div className="mb-14 sm:mb-20">
          <div ref={specsHeaderRef} className="text-center mb-10 sm:mb-12 scroll-animate-fade-up">
            <h3 className="text-2xl sm:text-3xl font-bold mb-4" style={{ color: '#B8860B' }}>
              Core Specializations
            </h3>
            <p className="text-base max-w-2xl mx-auto" style={{ color: '#555555' }}>
              Focused expertise in the areas that matter most for your transformation
            </p>
          </div>

          <div ref={specsRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
            {specializations.map((spec, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden transition-all duration-300 cursor-pointer bg-white scroll-animate-stagger"
                style={{ border: '1px solid #e0e0e0' }}
                onMouseEnter={e => {
                  e.currentTarget.style.borderColor = '#B8860B';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(184,134,11,0.15)';
                  e.currentTarget.style.transform = 'translateY(-6px)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.borderColor = '#e0e0e0';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div className="w-full h-40 overflow-hidden">
                  <img
                    src={spec.image}
                    alt={spec.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
                  />
                </div>
                <div className="p-5 text-center">
                  <h4 className="text-sm sm:text-base font-bold mb-2" style={{ color: '#1a1a1a' }}>
                    {spec.title}
                  </h4>
                  <p className="text-sm" style={{ color: '#555555' }}>
                    {spec.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Timeline */}
        <div>
          <div ref={timelineHeaderRef} className="text-center mb-10 sm:mb-12 scroll-animate-fade-up">
            <div className="inline-block mb-3">
              <span
                className="text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full"
                style={{ background: '#8B0000', color: '#ffffff' }}
              >
                The Journey
              </span>
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold mb-4" style={{ color: '#B8860B' }}>
              From Ottawa to the World
            </h3>
            <p className="text-base max-w-2xl mx-auto" style={{ color: '#555555' }}>
              A legacy built one city at a time, now reaching every corner of the globe
            </p>
          </div>

          <div className="relative">
            <div
              className="hidden lg:block absolute top-10 left-0 right-0 h-1"
              style={{ background: 'linear-gradient(90deg, #B8860B, #8B0000)' }}
            ></div>

            <div ref={timelineRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 relative">
              {timeline.map((item, index) => (
                <div
                  key={index}
                  className="text-center scroll-animate-stagger"
                >
                  <div
                    className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center rounded-full mx-auto mb-4 relative z-10"
                    style={{ background: 'linear-gradient(135deg, #B8860B, #8B0000)', boxShadow: '0 4px 16px rgba(139,0,0,0.25)' }}
                  >
                    <i className={`${item.icon} text-2xl sm:text-3xl`} style={{ color: '#ffffff' }}></i>
                  </div>
                  <div
                    className="inline-block px-3 py-1 rounded-full mb-3 text-xs font-bold"
                    style={{ background: '#8B0000', color: '#ffffff' }}
                  >
                    {item.year}
                  </div>
                  <h4 className="text-base sm:text-lg font-bold mb-2" style={{ color: '#1a1a1a' }}>
                    {item.city}
                  </h4>
                  <p className="text-sm leading-relaxed" style={{ color: '#555555' }}>
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}